import { ApiError } from '@/api/errors';

/** Retries after the first failure — three attempts in total. */
const MAX_RETRIES = 2;

/**
 * Whether a failed query is worth asking again.
 *
 * Only transient failures are: the network dropped, the server hiccupped
 * (5xx), or it asked us to slow down (408/429). Everything else is
 * deterministic — a 4xx says the request is wrong, and `invalid_response`
 * says the server's answer does not match the schema — so a retry would
 * re-download the same bytes and fail the same way. On 2026-09-13 that turned
 * one schema mismatch on the site-copy catalog into a triple request and a
 * multi-second spinner in front of the real error.
 */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (failureCount >= MAX_RETRIES) return false;
  if (!(error instanceof ApiError)) return true;
  if (error.code === 'invalid_response') return false;
  const { status } = error;
  if (status === 408 || status === 429) return true;
  if (status >= 400 && status < 500) return false;
  return true;
}
